// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Redux:
import { toggleAccountDropdown } from 'actions/site'

class MobileAppSetStationNudge extends React.Component {
	render() {
		const { toggleAccountDropdown } = this.props

		return (
			<div className="mobile-app-station-nudge" onClick={ toggleAccountDropdown }>
				<span>Start by setting your station</span>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		toggleAccountDropdown() {
			dispatch( toggleAccountDropdown() )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( MobileAppSetStationNudge )
